import PropTypes from 'prop-types';
import * as ICONS from './svgs';
import * as ICON_TYPES from '../../config/icon-types';
import './style.css';

/**
 * Renders an svg icon of the specified type
 * @param {*} props Props passed to this component
 * @returns {React.ReactComponentElement}
 */
const Icon = props => {
	const classes = ['adi-isp__icon'];
	const { className, type } = props;
    const typeInMacroCase = type.split('-').join('_').toUpperCase();

	classes.push(`${classes[0]}--${type}`);
	if (className) classes.push(className);

	return <i className={classes.join(' ')}>{ICONS[typeInMacroCase]}</i>;
};

Icon.defaultProps = {
	className: '',
};

Icon.propTypes = {
	className: PropTypes.string,
	type: PropTypes.oneOf([
		ICON_TYPES.TYPE_COPY_LINK_CHAIN,
		ICON_TYPES.TYPE_CHEVRON_DOWN,
		ICON_TYPES.TYPE_DOWNLOAD_FILE,
		ICON_TYPES.TYPE_OPEN_IN_NEW_TAB,
		ICON_TYPES.TYPE_OPEN_IN_NEW_TAB_SMALL,
		ICON_TYPES.TYPE_PDF_DOCUMENT,
		ICON_TYPES.TYPE_SELECTED_OPTION,
		ICON_TYPES.TYPE_SHARE_NODES,
		ICON_TYPES.TYPE_SHARE_ARROW,
		ICON_TYPES.TYPE_SPANNER_TOOL,
	]).isRequired,
};

export default Icon;
